import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.2322 1.82833C19.1582 0.654906 16.7019 0 14 0C11.2981 0 8.84185 0.654906 6.76777 1.82833C4.6937 3.00176 3.00176 4.6937 1.82833 6.76777C0.654906 8.84185 0 11.2981 0 14C0 16.7019 0.654906 19.1582 1.82833 21.2322C3.00176 23.3063 4.6937 24.9982 6.76777 26.1717C8.84185 27.3451 11.2981 28 14 28C16.7019 28 19.1582 27.3451 21.2322 26.1717C23.3063 24.9982 24.9982 23.3063 26.1717 21.2322C27.3451 19.1582 28 16.7019 28 14C28 11.2981 27.3451 8.84185 26.1717 6.76777C24.9982 4.6937 23.3063 3.00176 21.2322 1.82833ZM15.4582 11.5025C15.481 10.9558 15.0528 10.5 14.501 10.5H11.0015C10.7296 10.5 10.5 10.7239 10.5 11V11.1502C10.5 11.3438 10.6374 11.5661 10.8069 11.6476L12.1287 12.283C12.373 12.4005 12.5904 12.7218 12.6031 12.9954L12.9582 21.4975C12.981 22.0442 13.4477 22.5 14 22.5L14.1176 22.4933C14.62 22.4353 15.0203 22.0116 15.0418 21.4975L15.4582 11.5025ZM15.5 7C15.5 6.17157 14.8284 5.5 14 5.5C13.1716 5.5 12.5 6.17157 12.5 7C12.5 7.82843 13.1716 8.5 14 8.5C14.8284 8.5 15.5 7.82843 15.5 7Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgInfoFilled);
export { ForwardRef as ReactComponent };
